// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"gq-z","breadcrumbForward":"hq-z","breadcrumbBack":"iq-z","selected":"jq-z"};